import React from 'react';
import Form from 'react-bootstrap/Form';
import { PTC_TEXTO_MERCADERIA_MAX } from '../../vistas/invoice/invoicePtcTextosMercaderia';

const TextosMercaderiaPtcFields = ({
  arriba,
  abajo,
  onChangeArriba,
  onChangeAbajo,
  className = 'mb-3',
  variant = 'bootstrap',
}) => {
  const renderField = (label, value, onChange, posicion) => {
    const length = String(value || '').length;
    if (variant === 'input-group') {
      return (
        <div className={className} key={posicion}>
          <div className="input-group">
            <span className="input-group-text">{label}</span>
            <textarea
              className="form-control"
              rows={2}
              maxLength={PTC_TEXTO_MERCADERIA_MAX}
              placeholder="Texto que aparecerá en el PDF PTC"
              value={value || ''}
              onChange={(e) => onChange(e.target.value)}
            />
          </div>
          <small className="text-muted">{length}/{PTC_TEXTO_MERCADERIA_MAX} caracteres</small>
        </div>
      );
    }
    return (
      <Form.Group className={className} key={posicion}>
        <Form.Label className="mb-1">{label}</Form.Label>
        <Form.Control
          as="textarea"
          rows={2}
          maxLength={PTC_TEXTO_MERCADERIA_MAX}
          placeholder="Texto que aparecerá en el PDF PTC"
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
        />
        <small className="text-muted">{length}/{PTC_TEXTO_MERCADERIA_MAX} caracteres</small>
      </Form.Group>
    );
  };

  return (
    <div className={variant === 'bootstrap' ? 'border rounded p-3 mb-3 bg-light' : ''}>
      {variant === 'bootstrap' ? (
        <div className="d-flex justify-content-between align-items-center mb-2">
          <Form.Label className="mb-0">Textos alternativos de mercadería PTC</Form.Label>
          <small className="text-muted">Máximo {PTC_TEXTO_MERCADERIA_MAX} caracteres por texto</small>
        </div>
      ) : null}
      {renderField(
        'Texto arriba de toda la mercadería',
        arriba,
        onChangeArriba,
        'arriba'
      )}
      {renderField(
        'Texto abajo de toda la mercadería',
        abajo,
        onChangeAbajo,
        'abajo'
      )}
    </div>
  );
};

export default TextosMercaderiaPtcFields;
